import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { useMakeAPaymentCommitments } from '@sola/supporter-sdk/hooks/commitments.ts';
import { LocalAlertsProvider } from '../../molecules/local-alerts/local-alerts-provider.tsx';
import { MakeAPaymentAlert, MakeAPaymentAlertType } from '../../molecules/make-a-payment-alert/make-a-payment-alert.tsx';
import { MakeAPaymentSheet } from './make-a-payment-sheet.tsx';
export interface MakeAPaymentNoticeProps {
  onlyShowMissingPayment?: boolean;
}
export const MakeAPaymentNotice: React.FC<MakeAPaymentNoticeProps> = t0 => {
  const $ = _c(18);
  const {
    onlyShowMissingPayment: t1
  } = t0;
  const onlyShowMissingPayment = t1 === undefined ? false : t1;
  const [isOpen, setIsOpen] = useState(false);
  const {
    amountDue,
    hasMissedPayment,
    hasDueThisMonth,
    canPayAhead,
    alertCommitments
  } = useMakeAPaymentCommitments();
  if (!hasMissedPayment && onlyShowMissingPayment || !hasMissedPayment && !hasDueThisMonth && !canPayAhead) {
    return;
  }
  let t2;
  if ($[0] !== hasMissedPayment) {
    t2 = hasMissedPayment && {
      alertType: MakeAPaymentAlertType.missingPayment
    };
    $[0] = hasMissedPayment;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== hasDueThisMonth || $[3] !== hasMissedPayment) {
    t3 = hasDueThisMonth && !hasMissedPayment && {
      alertType: MakeAPaymentAlertType.paymentDue
    };
    $[2] = hasDueThisMonth;
    $[3] = hasMissedPayment;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== alertCommitments || $[6] !== amountDue || $[7] !== t2 || $[8] !== t3) {
    t4 = {
      amountDue,
      commitments: alertCommitments,
      alertType: MakeAPaymentAlertType.payAhead,
      ...t2,
      ...t3
    };
    $[5] = alertCommitments;
    $[6] = amountDue;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const makeAPaymentAlert = t4;
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setIsOpen(true);
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== makeAPaymentAlert) {
    t6 = <MakeAPaymentAlert {...makeAPaymentAlert} onButtonClick={t5} />;
    $[11] = makeAPaymentAlert;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== isOpen) {
    t7 = <MakeAPaymentSheet open={isOpen} onOpenChange={setIsOpen} />;
    $[13] = isOpen;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t6 || $[16] !== t7) {
    t8 = <LocalAlertsProvider>{t6}{t7}</LocalAlertsProvider>;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
};